import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.14.9_@swc+helpers@0.5.23_@types+react@19.3.0_next@16.4.3_@babel+core@7.29.7_d9ec317634fe689e5194129f8f20e21a/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/src/shared/lib/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/widgets/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderLayoutWrapper"] */ "/app/src/widgets/header/header-layout-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/widgets/header/header.tsx");
